<script lang="ts">
export let areas: {slug?:string,name?:string}[] = [];

</script>

<section class="area_selector">
	<div>
		<h4 class="display-m">Online delivery all over South Africa</h4>
	</div>
	<article>
		{#each areas as item}
			<a href={`/delivery/in/${item.slug}`}>
				<h5 class="headline-s">{item.name}</h5>
				<span class="icon-chevron-right-28"></span>
			</a>
		{/each}
	</article>
</section>

<style lang="scss">
	@use 'color';
	@use 'screen';

	.area_selector {
		margin: 4rem 0;
		@media(min-width: 720px) { margin: 6rem 0; }
		@media(screen.$md) {
			margin: 7rem 0;
			display: flex;
		}
		@media(screen.$mdl) { margin: 9rem 0; }
		@media(screen.$lg) { margin: 10rem 0; }
		>div {
			display: flex;
			justify-content: center;
			margin-bottom: 3rem;
			@media(screen.$md) { width: 25%; }
			h4 {
				text-align: center;
				max-width: 360px;
			}
		}
		article {
			@media(screen.$md) {
				display: flex;
				flex-direction: column;
				width: 70%;
				padding-left: 5rem;
			}
			@media(screen.$lg) { padding-left: 8rem; }
			a {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 1.2rem 0;
				border-bottom: 2px solid color.$separator;
				&:hover {
					border-bottom: 4px solid color.$on-surface;
				}
				h5 { margin: 0; }
			}
		}
	}
</style>